import {Controller} from "@hotwired/stimulus"
import $ from "jquery"
// Connects to data-controller="cctv--range-slider"

export default class extends Controller {

  static values = {
    date: String,
    timeMin: String,
    timeMax: String,
    type: String
  }

  connect() {
    this.initSlider(new Date(this.dateValue))

    document.addEventListener("archive:play", (e) => {
      e.detail.callback($(this.element).dateRangeSlider("values"))
    })

    $(this.element).dateRangeSlider().bind("valuesChanged", function (e, data) {

      document.dispatchEvent(
        new CustomEvent("play-archive", {
            detail: {
              min: data.values.min,
              max: data.values.max
            }
          }
        ))

      document.dispatchEvent(
        new CustomEvent("reply", {
            detail: {
              min: data.values.min,
              max: data.values.max
            }
          }
        ))


    });

  }

  initSlider(date) {
    const now = new Date();
    const isToday = this.isToday(date);
    let maxBound = isToday ? now : this.endOfDay(date);

    let defaultMax = new Date(date.getTime());
    if (isToday && defaultMax > now) {
      defaultMax = new Date(now.getTime());
    } else {
      defaultMax.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    }

    let defaultMin = new Date(defaultMax.getTime() - 10 * 60 * 1000);

    if (this.timeMinValue) defaultMin = new Date(this.timeMinValue);
    if (this.timeMaxValue) defaultMax = new Date(this.timeMaxValue);

    if (isToday) {
      if (defaultMax > now) defaultMax = new Date(now.getTime());
      if (defaultMin > defaultMax) defaultMin = new Date(defaultMax.getTime() - 10 * 60 * 1000);
    }

    let startOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    if (defaultMin < startOfDay) defaultMin = new Date(startOfDay.getTime());

    if (this.typeValue === "replay") startOfDay = new Date(now.setMinutes(now.getMinutes() - 10))
    if (this.typeValue === "replay") maxBound = new Date()
    if (this.typeValue === "replay") defaultMin = new Date(now.setMinutes(now.getMinutes() - 2))


    $(this.element).dateRangeSlider({
      symmetricPositionning: true,
      bounds: {
        min: startOfDay,
        max: maxBound
      },
      defaultValues: {
        min: defaultMin,
        max: defaultMax
      },
      step: {minutes: 1},
      formatter: (value) =>
        new Date(value).toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1"),
        scales: this.typeValue === "replay"
          ? (() => {
            const firstTs = new Date(startOfDay).setSeconds(0, 0)

            return [
              {
                first: (value) => {
                  const v = new Date(value)
                  v.setSeconds(0, 0)
                  return v
                },
                end: (value) => value,
                next: (value) => {
                  const next = new Date(value)
                  next.setMinutes(next.getMinutes() + 1)
                  next.setSeconds(0, 0)
                  return next
                },
                label: (value) => {
                  const v = new Date(value)
                  v.setSeconds(0, 0)

                  if (v.getTime() === firstTs) return ""

                  const hh = String(v.getHours()).padStart(2, "0")
                  const mm = String(v.getMinutes()).padStart(2, "0")
                  return `${hh}:${mm}`
                }
              }
            ]
          })()
          : [
            {
              first: (value) => value,
              end: (value) => value,
              next: (value) => {
                const next = new Date(value)
                return new Date(next.setHours(value.getHours() + 1))
              },
              label: (value) => `${value.getHours()}:00`
            }
          ]

    });
  }

  isToday(date) {
    const now = new Date()
    return (
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() &&
      date.getDate() === now.getDate()
    )
  }

  endOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
  }

  disconnect() {
    document.removeEventListener("archive:play", (e) => {
      e.detail.callback($(this.element).dateRangeSlider("values"))
    })

    super.disconnect();
  }

}
